/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, PageGridContainer } from '@coursera/cds-core';

type Props = { children: React.ReactNode; maxWidth?: 'xl' | 'lg' | 'md' };

export const Footer = (props: Props): React.ReactElement => {
  const { children, maxWidth = 'lg' } = props;

  return (
    <nav
      css={css`
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        padding: var(--cds-spacing-200) 0;
        background: var(--cds-color-white-0, #fff);
        z-index: 1;
        border-top: 1px solid var(--cds-color-neutral-stroke-primary-weak);
      `}
    >
      <PageGridContainer maxWidth={maxWidth as 'lg'}>
        <Grid item xs={12}>
          {children}
        </Grid>
      </PageGridContainer>
    </nav>
  );
};

export default Footer;
